import { Checkbox as AntCheckbox } from 'antd'
import type { ComponentProps } from 'react'

type AntCheckboxProps = ComponentProps<typeof AntCheckbox>

export interface AppCheckboxProps extends AntCheckboxProps {}

export const AppCheckbox = ({ ...rest }: AppCheckboxProps) => <AntCheckbox {...rest} />

export const AppCheckboxGroup = AntCheckbox.Group
